import { PaletteOptions } from '@mui/material';
import { colors } from '@themes/colors';

export const lightColorPalette: PaletteOptions = {
  mode: 'light',
  background: {
    default: '#F3F3F3',
    paper: '#FFFFFF',
  },
  primary: {
    main: colors.primary.mainGreen,
    light: colors.primary.lightGreen,
    dark: colors.primary.darkGreen,
    contrastText: colors.background.black,
  },
  secondary: {
    main: colors.secondary.black,
    light: '#E6ECED',
    dark: '#2A4959',
    contrastText: colors.text.primary,
  },
  info: {
    main: colors.secondary.lightBlue,
    light: colors.secondary.darkBlueGrey,
    dark: colors.secondary.blueGrey,
  },
  success: {
    main: colors.primary.mainGreen,
    light: colors.primary.complimentaryGreen,
    dark: colors.primary.darkGreen,
  },

  warning: {
    main: colors.secondary.yellowBrand,
    light: colors.secondary.lightYellow,
    dark: '#c19d29',
  },

  error: {
    main: '#f2653d',
    dark: colors.secondary.red,
    light: colors.secondary.lightRed,
  },
  text: {
    primary: colors.text.primary,
    secondary: colors.text.secondary,
  },
};
